import { observer } from "mobx-react";
import * as React from "react";
import { Redirect, Route } from "react-router-dom";
import { authStore } from "../../../stores/AuthStore";
import { history } from "./history";
import { Routes } from "./Routes";

export const PrivateRoute = observer(({ component: Component, ...props }: any) => {
    const isAuthenticated = authStore.isAuthenticated;

    if (!isAuthenticated) {
        authStore.redirectAfterLogin = history.location.pathname + history.location.search + history.location.hash;
    }

    return (
        <Route
            {...props}
            render={(routeProps) => {
                return isAuthenticated ? (
                    <Component {...routeProps} />
                ) : (
                    <Redirect
                        to={{
                            pathname: Routes.LOGIN
                        }}
                    />
                );
            }}
        />
    );
});
